import api from './api';
import type { MarketingTrend, MarketingBreakdownItem, FunnelData, EfficiencyDay, AudienceDemographics, MessagingOverview, UnifiedFunnel, FunnelTrendDay, PancakeTagCounts } from '../types/marketing';

interface DateRangeParams {
  from: string;
  to: string;
}

export const marketingApi = {
  async getMarketingTrend(params: DateRangeParams & { groupBy?: 'day' | 'month' }): Promise<MarketingTrend[]> {
    const { data } = await api.get('/marketing/trend', { params });
    return data;
  },
  async getByCampaign(params: DateRangeParams): Promise<MarketingBreakdownItem[]> {
    const { data } = await api.get('/marketing/by-campaign', { params });
    return data;
  },
  async getByAccount(params: DateRangeParams): Promise<MarketingBreakdownItem[]> {
    const { data } = await api.get('/marketing/by-account', { params });
    return data;
  },
  async getByActionType(params: DateRangeParams): Promise<MarketingBreakdownItem[]> {
    const { data } = await api.get('/marketing/by-action-type', { params });
    return data;
  },
  async getFunnel(params: DateRangeParams): Promise<FunnelData> {
    const { data } = await api.get('/marketing/funnel', { params });
    return data;
  },
  async getEfficiencyTrend(params: DateRangeParams): Promise<EfficiencyDay[]> {
    const { data } = await api.get('/marketing/efficiency-trend', { params });
    return data;
  },
  async getAudienceDemographics(): Promise<AudienceDemographics> {
    const { data } = await api.get('/marketing/audience');
    return data;
  },
  async getMessagingOverview(params: DateRangeParams): Promise<MessagingOverview> {
    const { data } = await api.get('/marketing/messaging', { params });
    return data;
  },
  async getUnifiedFunnel(params: DateRangeParams): Promise<UnifiedFunnel> {
    const { data } = await api.get('/marketing/funnel-unified', { params });
    return data;
  },
  async getFunnelTrend(params: DateRangeParams): Promise<FunnelTrendDay[]> {
    const { data } = await api.get('/marketing/funnel-trend', { params });
    return data;
  },
  async getPancakeTagCounts(params: DateRangeParams): Promise<PancakeTagCounts> {
    const { data } = await api.get('/marketing/pancake-tags', { params });
    return data;
  },
  async getLifecycleCounts(params: DateRangeParams): Promise<{ leads: number; mql: number; opp: number; customers: number }> {
    const { data } = await api.get('/marketing/lifecycle-counts', { params });
    return data;
  },
};
